import { render, staticRenderFns } from "./profile-view-disciplinary.vue?vue&type=template&id=5efa7a88&scoped=true&"
import script from "./profile-view-disciplinary.vue?vue&type=script&lang=js&"
export * from "./profile-view-disciplinary.vue?vue&type=script&lang=js&"
import style0 from "./profile-view-disciplinary.vue?vue&type=style&index=0&id=5efa7a88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa7a88",
  null
  
)

export default component.exports